import { digitsOnly } from './cpfCnpj';

export const normalizeSearchText = (value) =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .trim();

export const fieldMatchesSearch = (fieldValue, searchTerm, { digitFields = false } = {}) => {
  const term = String(searchTerm || '').trim();
  if (!term || fieldValue == null || fieldValue === '') return false;

  if (digitFields) {
    const termDigits = digitsOnly(term);
    if (termDigits) {
      return digitsOnly(fieldValue).includes(termDigits);
    }
  }

  return normalizeSearchText(fieldValue).includes(normalizeSearchText(term));
};

export const matchesDocumentSearch = (fieldValue, searchTerm) =>
  fieldMatchesSearch(fieldValue, searchTerm, { digitFields: true });

export const matchesPhoneSearch = (fieldValue, searchTerm) =>
  matchesDocumentSearch(fieldValue, searchTerm);

const USER_TEXT_FIELDS = ['name', 'email', 'company'];
const USER_DIGIT_FIELDS = ['cpfcnpj', 'fone'];

const shouldUseDigitFieldsForToken = (token) => {
  if (token.includes('@')) return false;
  const termDigits = digitsOnly(token);
  if (termDigits.length < 4) return false;
  return termDigits.length >= token.length * 0.5;
};

export const matchesUserSearch = (user, searchTerm) => {
  const rawTerm = String(searchTerm || '').trim();
  if (!rawTerm) return true;

  const tokens = rawTerm.split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return true;

  return tokens.every((token) => {
    const textMatch = USER_TEXT_FIELDS.some((key) =>
      fieldMatchesSearch(user?.[key], token)
    );
    if (textMatch) return true;

    if (!shouldUseDigitFieldsForToken(token)) {
      return false;
    }

    return USER_DIGIT_FIELDS.some((key) =>
      fieldMatchesSearch(user?.[key], token, { digitFields: true })
    );
  });
};

export const matchesCompanySearch = (item, searchTerm) => {
  const rawTerm = String(searchTerm || '').trim();
  if (!rawTerm) return true;

  const tokens = rawTerm.split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return true;

  return tokens.every((token) => {
    const textMatch = ['name', 'ncontract'].some((key) =>
      fieldMatchesSearch(item?.[key], token)
    );
    if (textMatch) return true;

    return matchesDocumentSearch(item?.cnpj, token);
  });
};
